/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Typography, Button, Input, Card } from "@material-tailwind/react";
import { RocketLaunchIcon, UserGroupIcon, BellIcon } from "@heroicons/react/24/outline";
import Footersection from "../views/Home/Footersection";
import Navbarsection from "../views/Home/Navbarsection";

export default function TeamComingSoon() {
  const [email, setEmail] = useState("");

  // Animation variants for staggered entrance
  const containerVars = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 }
    }
  };

  const itemVars = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.8, ease: "easeOut" } }
  };

  return (
    <>
    
      <Navbarsection/>
        <div className="relative min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4 overflow-hidden">
    
      {/* Cinematic Background Elements */}
      <div className="absolute top-[10%] left-[-10%] w-[50%] h-[50%] bg-orange-600/20 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-orange-900/20 rounded-full blur-[100px]" />

      <motion.div 
        variants={containerVars}
        initial="hidden"
        animate="visible"
        className="mt-8 relative z-10 max-w-4xl w-full text-center"
      >
        {/* Badge */}
        <motion.div variants={itemVars} className="flex justify-center mb-6">
          <div className="flex items-center gap-2 bg-orange-600/10 border border-orange-600/30 px-4 py-1.5 rounded-full">
            <UserGroupIcon className="h-4 w-4 text-orange-500" />
            <span className="text-orange-500 text-xs font-black uppercase tracking-[0.2em]">Our Team is Evolving</span>
          </div>
        </motion.div>

        {/* Heading */}
        <motion.h1 variants={itemVars} className="text-6xl md:text-8xl font-black text-white tracking-tighter leading-none mb-6">
          MEET THE <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 via-orange-400 to-orange-200">
            CHANGEMAKERS
          </span>
        </motion.h1>

        <motion.p variants={itemVars} className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto mb-12 font-medium">
          We’re currently assembling a gallery of our dedicated social workers, 
          innovators, and volunteers. Something big is brewing at Mahakal Social Welfare Society.
        </motion.p>

        {/* Teaser Avatars */}
        <motion.div variants={itemVars} className="flex justify-center -space-x-4 mb-16">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="w-16 h-16 rounded-full border-4 border-[#0a0a0a] bg-orange-900 flex items-center justify-center overflow-hidden grayscale hover:grayscale-0 transition-all duration-500 cursor-help scale-100 hover:scale-110">
               <span className="text-orange-500 font-black">?</span>
            </div>
          ))}
          <div className="w-16 h-16 rounded-full border-4 border-[#0a0a0a] bg-orange-600 flex items-center justify-center text-white font-black text-xs">
            +12
          </div>
        </motion.div>

        {/* Notify Form */}
        <motion.div variants={itemVars} className="max-w-md mx-auto">
          <Card className="bg-white/5 backdrop-blur-md border border-white/10 p-2 rounded-2xl flex flex-row items-center gap-2">
            <div className="flex-grow pl-4">
              <input 
                type="email" 
                placeholder="Enter email to get notified"
                className="w-full bg-transparent border-none outline-none text-white placeholder:text-gray-600"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <Button 
              className="bg-orange-600 hover:bg-orange-500 text-white rounded-xl px-6 py-3 flex items-center gap-2 transition-all active:scale-95 shadow-lg shadow-orange-600/20"
            >
              <BellIcon className="h-5 w-5" />
              <span className="hidden sm:inline font-bold">NOTIFY ME</span>
            </Button>
          </Card>
          <p className="text-gray-600 text-[10px] mt-4 uppercase tracking-widest font-bold">
            Be the first to see our new faces • March 2026
          </p>
        </motion.div>
      </motion.div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 z-0 opacity-[0.03] pointer-events-none" 
           style={{ backgroundImage: `radial-gradient(#fb8c00 1px, transparent 1px)`, backgroundSize: '30px 30px' }} 
      />
    </div>
      <Footersection/>
      </>
  
  );
}

